import { createStore } from 'redux'
import rootReducer from './redux/reducers'

export default createStore(rootReducer)